// extracted by mini-css-extract-plugin
export default {"white":"button_white__9k51q","hoverable":"button_hoverable__20qom","black":"button_black__audAw","maxWidth":"button_maxWidth__L9+1M"};